import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, InputGroup, FormControl, Form } from 'react-bootstrap';
import { ValidatorCustom } from '../validator';
import { Translate } from 'react-redux-i18n';
import InputGroupCustom from './InputGroupCustom';
import FormTitleCC from './component/FormTitleCC';

const FeeSingleCurrencyInput = ({
  currencySymbol,
  handleChange,
  validatorCallback,
  isSubmitted,
  valid,
  placeholder,
  value,
  validCases,
  idValidationFinal,
  textGRAppend,
  disabled,
  isForcePercent,
  children,
}) => {
  return (
    <FormGroup
      className={
        !isSubmitted ? null : valid?.[idValidationFinal] === false ? 'error' : null
      }
    >
      {children}
      <div className="input-with-validator">
        <InputGroupCustom
          textGRPrepend={isForcePercent ? '%' : currencySymbol}
          textGRAppend={textGRAppend}
        >
          <FormControl
            type="number"
            value={value}
            onChange={(e) => handleChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
          />
        </InputGroupCustom>
        <ValidatorCustom
          validatorCallback={validatorCallback}
          id={idValidationFinal}
          validCases={validCases}
          value={value}
          isSubmitted={isSubmitted}
        />
      </div>
    </FormGroup>
  );
};

FeeSingleCurrencyInput.propTypes = {
  currencySymbol: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  validatorCallback: PropTypes.func,
  isSubmitted: PropTypes.bool,
  valid: PropTypes.object,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  className: PropTypes.string,
  validCases: PropTypes.arrayOf(PropTypes.string),
  groupPrepend: PropTypes.string,
};

FeeSingleCurrencyInput.defaultProps = {
  currencySymbol: '$',
  validatorCallback: () => {},
  isSubmitted: false,
  valid: {},
  placeholder: '',
  value: '',
  title: '',
  validCases: [],
};

export default FeeSingleCurrencyInput;
